import BaseLayoutWithHeaderAndSideBar from '@/layout/BaseLayoutWithHeaderAndSideBar.vue'
import AppHome from '@/modules/app/home/AppHome.vue'
import SidebarDefault from '@/components/general/SidebarDefault.vue'
import JurisdictionRoutes from '@/modules/app/jurisdiction/routes'
import PolicyRoutes from '@/modules/app/policy/routes'

export default [
  {
    path: '/',
    component: BaseLayoutWithHeaderAndSideBar,
    meta: {
      sidebar: {
        size: 'medium',
        content: SidebarDefault
      },
    },
    children: [
      {
        path: '',
        name: 'AppHome',
        component: AppHome,
        meta: {
          header: null,
          sidebar: null,
        }
      },

      ...PolicyRoutes,
      ...JurisdictionRoutes,
      
    ]
  } 
]